module.exports = __webpack_public_path__ + "img/blue-tick.1e1e0679.svg";